export default __webpack_public_path__ + "static/media/success.d59f37a2.svg";